.slider {
  position: relative;
  overflow: hidden; }

.slider-tray::-webkit-scrollbar {
  display: none; }

.slider-tray.css-only {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }

.slide {
  flex-shrink: 0;
  scroll-snap-align: start;
  scroll-snap-stop: normal; }

.slide-inner-padding {
  position: relative; }

.slide-inner-wrapper.fixed-size {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0; }

.slide.align-center {
  scroll-snap-align: center; }

.slide.snap-stop {
  scroll-snap-stop: always; }

.slider-tray.css-only.scroll-snap {
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory; }

.slider-bar-track {
  background-color: #eee;
  position: relative;
  height: 10px; }

.slider-bar-thumb {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #555; }

.slider-bar-dot-group {
  display: flex;
  justify-content: center;
  position: relative; }

.slider-dot-wrapper {
  padding: 5px;
  cursor: pointer; }

.slider-dot {
  height: 8px;
  width: 8px;
  border-radius: 10rem;
  background-color: #555; }

.slider-dot-wrapper:not(.dynamic) .slider-dot {
  background-color: #ddd; }

.slider-dot-wrapper:not(.dynamic).active .slider-dot {
  background-color: #666; }
